import queryString from "query-string";

import Service from "shared/payment/services";
import { getQuery } from "analytics/util/helpers";
import { isMobile } from "shared/util/EnvironmentHelpers";
import {
	openCreditCard as paymentOpenCreditCard,
	setProducts as paymentSetProducts,
	openPaypal as paymentOpenPaypal,
	setDiscountId as paymentSetDiscountId,
} from "ducks/payment";

import {
	PRODUCT_TYPES,
	PRODUCT_SUBTYPES,
	DEFAULT_ALIST_PACKAGE_DURATION_MOBILE,
} from "shared/payment/constants";


// initial state
// ----------------------------------------------------------------------------

export const INITIAL_STATE = {
	selectedProductPackage: {},
	productPackages: [],
	isLoading: true,
	isPurchased: false,
	isPremium: false,
	discount: 0,
	discountId: "",
	rateCardName: "",
};


// action types
// ----------------------------------------------------------------------------

export const LOAD = "alistpackages.LOAD";
export const SET_PREMIUM_STATUS = "alistpackages.SET_PREMIUM_STATUS";
export const SET_SELECTED_PRODUCT_PACKAGE = "alistpackages.SET_SELECTED_PRODUCT_PACKAGE";
export const SET_PRODUCT_PACKAGES = "alistpackages.SET_PRODUCT_PACKAGES";
export const OPEN_PAYMENT_MODAL = "alistpackages.OPEN_PAYMENT_MODAL";

// reducer
// ----------------------------------------------------------------------------

export default (state = INITIAL_STATE, action) => {
	switch (action.type) {
		case SET_PREMIUM_STATUS: {
			return {
				...state,
				isPremium: action.payload,
				isLoading: true,
			};
		}

		case SET_PRODUCT_PACKAGES: {
			return {
				...state,
				productPackages: action.payload.productPackages,
				discount: action.payload.discount,
				discountId: action.payload.discountId,
				isLoading: false,
				rateCardName: action.payload.rateCardName,
			};
		}

		case SET_SELECTED_PRODUCT_PACKAGE: {
			return {
				...state,
				selectedProductPackage: action.payload.selectedProductPackage,
			};
		}

		case OPEN_PAYMENT_MODAL: {
			return state;
		}

		default: {
			return state;
		}
	}
};

// actions
// ----------------------------------------------------------------------------

const setPremiumStatus = (status) => ({
	type: SET_PREMIUM_STATUS,
	payload: status,
});

export const loadPage = () => ({ type: LOAD });

export const setSelectedProductPackage = (productPackageId) => (dispatch, getState) => {
	const { productPackages, rateCardName, isPremium } = getState().alistPackages;

	const selectedProductPackage = productPackages
		.filter(({ productid }) => productid === productPackageId)[0];

	dispatch({
		type: SET_SELECTED_PRODUCT_PACKAGE,
		payload: {
			selectedProductPackage,
			rateCardName,
			isPremium,
		},
	});
};

export const fetchProductPackages = (isPremium) => (dispatch) => {
	dispatch(setPremiumStatus(!!isPremium));

	Service.getProductPackages({
		productType: PRODUCT_TYPES.SUBSCRIPTION,
		productSubtype: isPremium ? PRODUCT_SUBTYPES.ALISTPREMIUM : PRODUCT_SUBTYPES.ALIST,
	})
		.then(({ discount, productPackages, discountId, rateCardName }) => {
			// if there are no results, redirect (same logic in payment ducks)
			if (!productPackages) {
				window.location.href = "/doubletake";
			}

			let defaultProduct;

			if (isMobile) {
				defaultProduct = productPackages.find((p) => {
					return p.subPeriod === DEFAULT_ALIST_PACKAGE_DURATION_MOBILE;
				});
			}

			if (!defaultProduct) {
				defaultProduct = productPackages[0];
			}

			dispatch({
				type: SET_PRODUCT_PACKAGES,
				payload: {
					productPackages,
					discount,
					discountId,
					rateCardName,
					isPremium,
				},
			});
			dispatch(setSelectedProductPackage(defaultProduct.productid));
		});
};

export const openPayment = () => (dispatch, getState) => {
	const {
		selectedProductPackage,
		productPackages,
		discountId,
		rateCardName,
	} = getState().alistPackages;

	dispatch({ type: OPEN_PAYMENT_MODAL, payload: { isPaypal: false } });
	dispatch(paymentSetProducts(productPackages, rateCardName));
	dispatch(paymentSetDiscountId(discountId));
	dispatch(paymentOpenCreditCard(selectedProductPackage));
};

export const openPaymentMobile = () => (dispatch, getState) => {
	const { selectedProductPackage } = getState().alistPackages;

	// redirect to a thing
	const qs = {
		productid: selectedProductPackage.productid,
		type: selectedProductPackage.productSubtype,
		pd: getQuery("pd"),
		cf: getQuery("cf"),
	};

	window.location.href = `/payments?${queryString.stringify(qs)}`;
};

export const openPaymentPaypal = () => (dispatch, getState) => {
	const {
		selectedProductPackage,
		productPackages,
		discountId,
		rateCardName,
	} = getState().alistPackages;

	dispatch({ type: OPEN_PAYMENT_MODAL, payload: { isPaypal: true } });
	dispatch(paymentSetProducts(productPackages, rateCardName));
	dispatch(paymentSetDiscountId(discountId));
	dispatch(paymentOpenPaypal(selectedProductPackage));
};



// WEBPACK FOOTER //
// ./src/ducks/alist_packages.js